var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSettings(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.697 15.372c.058-.448.1-.896.1-1.372 0-.476-.042-.924-.1-1.372l3.037-2.31a.693.693 0 00.173-.896l-2.879-4.844c-.173-.308-.561-.42-.878-.308l-3.584 1.4a10.591 10.591 0 00-2.432-1.372l-.547-3.71C17.544.252 17.241 0 16.882 0h-5.757c-.36 0-.662.252-.706.588l-.547 3.71c-.877.35-1.683.826-2.432 1.372l-3.584-1.4a.711.711 0 00-.878.308L.1 9.422a.678.678 0 00.173.896l3.036 2.31c-.057.448-.1.91-.1 1.372 0 .462.043.924.1 1.372l-3.037 2.31a.693.693 0 00-.172.896l2.878 4.844c.173.308.562.42.878.308l3.584-1.4a10.59 10.59 0 002.432 1.372l.547 3.71c.044.336.346.588.706.588h5.757c.36 0 .662-.252.705-.588l.547-3.71c.878-.35 1.684-.826 2.432-1.372l3.584 1.4c.331.126.705 0 .878-.308l2.879-4.844a.693.693 0 00-.173-.896l-3.037-2.31zM14.003 18.9c-2.778 0-5.037-2.198-5.037-4.9 0-2.702 2.26-4.9 5.037-4.9 2.778 0 5.038 2.198 5.038 4.9 0 2.702-2.26 4.9-5.038 4.9z"
  })));
}

export default __webpack_public_path__ + "92381363f6d87f09848630cc6c479189.svg";
export { SvgSettings as ReactComponent };